import React from 'react';
import {formsStore} from '../../Form/stores/FormsStore';
import {FormSearch} from './FormSearch';
import {getServerTexts} from '../../../features/PartModal/texts';
import {roots} from '../../../index';

const dropdownRef: React.RefObject<typeof FormSearch> = React.createRef();

export async function renderSearch(root, props) {
    const key = `${formsStore.currentForm && formsStore.currentForm.name}_${props.fieldNum}_${
        props.row
    }`;

    //get text for parts modal because parts modal is not render via GWT
    await getServerTexts();

    // Check if this root is still the current one for this selector
    // This prevents rendering to an unmounted root

    if (roots && roots[props.selector] === root) {
        root.render(<FormSearch ref={dropdownRef} key={key} {...props} />);
    }

    return dropdownRef;
}
